module.exports = __webpack_public_path__ + "img/recommend.db7db7aa.png";